<template>
    <section class="m-blog-popular">
        <y-loading
            v-if="!articlesData"
            :active="$wait.is('loading-popular-articles')"
            size="60"
            height="470px"
            position="relative"
        />
        <div v-else>
            <div class="m-blog-popular__title">
                <h2>
                    {{ $t('blog.popular_articles') }}
                </h2>
            </div>
            <ul class="blog-list">
                <li
                    v-for="(post, i) in articlesData"
                    :key="i"
                    class="blog-item"
                >
                    <router-link
                        :to="{name: 'blog-single', params: {slug: post.slug}}"
                    >
                        <y-blog-card :post-data="post" />
                    </router-link>
                </li>
            </ul>
        </div>
    </section>
</template>

<script >

    import YBlogCard from '@modules/blog/components/Categories/BlogCard/BlogCard.vue';

    export default {
        name: 'BlogPopularArticles',

        components: {
            YBlogCard,
        },

        /**
         *
         * @inheritDoc
         */
        data() {
            return {
                articlesData: null,
            };
        },
        /**
         *
         * @inheritDoc
         */
        created() {
            this.fetch();
        },
        /**
         *
         * @inheritDoc
         */
        methods: {

            /**
             * Check the Promise.all Request Error
             *
             * @param {Array} req - Responses array
             * @param {index} index - number of response
             * @returns {boolean}
             */
            handleReq(req, index) {
                return req && req[index] && !req[index].isAxiosError;
            },

            /**
             * fetch hero data
             *
             * @returns {Promise}
             */
            fetch() {
                this.$wait.start('loading-popular-articles');

                const articles = this.$services.Content.postList({
                    type     : 'blog',
                    including: ['image', 'created_at', 'tagging_cats', 'title', 'synopsis', 'custom', 'user', 'publisher', 'url_encode', 'slug'],
                    limit    : 3,
                    locale   : this.$i18n.locale,
                    sort     : 'view_count',
                    user_id  : this.$route.params.id,
                }).catch((error) => {
                    this.handleError(error);
                });

                return Promise.all([articles])
                    .then((responses) => {
                        if (this.handleReq(responses, 0)) {
                            this.articlesData = responses[0].data.results;
                        }
                    })
                    .catch((error) => {
                        this.handleError(error);
                    })
                    .finally(() => {
                        this.$wait.end('loading-popular-articles');
                    });
            },
        },
    };

</script>

<style lang="scss" src="./popular-articles.scss"/>
